<template>
    <div class="multiselect-wrapper">
        <vue-multiselect
                v-model="value"
                :options="options"
                :searchable="true"
                :multiple="true"
                :label="label"
                :track-by="trackBy"
                placeholder=""
                :select-label="labelSelect"
                :deselect-label="labelDeselect"
                :selected-label="labelSelected"
        >
            <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
        </vue-multiselect>
        <div v-show="isPlaceholderVisible" class="multiselect-placeholder">{{ placeholder }}</div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
  components: {
    VueMultiselect
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'name'
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    checked:{
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {
      value: this.prepareValue(),
      labelSelect: Translator.trans('multiselect.select'),
      labelDeselect: Translator.trans('multiselect.remove'),
      labelSelected: Translator.trans('multiselect.selected'),
    }
  },
  computed: {
    isPlaceholderVisible() {
      return this.placeholder && !this.value.length
    }
  },
  watch : {
    value: function (value) {
      this.$emit('input', value.map(x => x[this.trackBy]))
    },
    options : function() {
      this.value = this.prepareValue()
    }
  },
  mounted() {
    this.value = this.prepareValue()
  },
  methods: {
    prepareValue() {

      let prepareValues = []

      for (let i = 0; i < this.options.length ; i++) {
        if (this.checked.indexOf(this.options[i][this.trackBy]) > -1) {
          let tmp = {}
          tmp[this.trackBy] = this.options[i][this.trackBy]
          tmp[this.label] = this.options[i][this.label]
          prepareValues.push(tmp)
        }
      }

      this.$emit('input', this.checked)
      return prepareValues
    }
  },

}
</script>

<style scoped>
.multiselect-wrapper {
    position: relative;
}

.multiselect-wrapper .multiselect-placeholder {
    color: #ccc;
    height: 100%;
    line-height: 34px;
    padding-left: 20px;
    pointer-events: none;
    position: absolute;
    top: 0;
    vertical-align: middle;
    width: 100%;
}
</style>
